import {isLoggedIn} from 'utils/auth'

export default (store) => ({
  path: 'tenant-config',
  onEnter: isLoggedIn(store),
  getComponent(nextState, callback) {
    require.ensure([], (require) => {
      const component = require('./TenantConfig').default
      callback(null, component)
    }, 'TenantConfig')
  }
})



// WEBPACK FOOTER //
// ./src/routes/rule-ui-routes/TenantConfig/index.js